module.exports = {
  endpoints: {
    RATING_REVIEW_BASE_URI: "https://reviews-service.tphub-qa.moveaws.com/api/external/v1/",
    RATING_REVIEW_BASE_URI_END_POINT: "feedback",
    RATING_REVIEW_USER_KEY: process.env.RATING_REVIEW_USER_KEY,

    PROFILE_SEARCH_API_PROSOFT_TOKEN: process.env.PROFILE_SEARCH_API_PROSOFT_TOKEN,
    PROFILE_SECURE_SEARCH_JWT_TOKEN: process.env.PROFILE_SECURE_SEARCH_JWT_TOKEN,
    PROFILE_SEARCH_API_CLIENT: "FAR2.0",
    PROFILE_SEARCH_API_VERSION: "v1",
    PROFILE_SEARCH_API_TIME_OUT: "500",
    PROFILE_SEARCH_API_BASE_URI: "https://eai-profile.tphub-qa.moveaws.com/restricted/",
    PROFILE_DOT_REALTOR_SEARCH_TOKEN: process.env.PROFILE_DOT_REALTOR_SEARCH_TOKEN,

    IPC_BASE_URI: "http://rdcms-qa.move.com",
    IPC_PROJECT_ID: "FAR2.0",

    MY_ACCT_BASE_URI: "https://myaccount-qa.realtor.com/",
    MY_ACCT_PROJECT_ID: "FAR2.0",

    GEO_API_BASE_URL: "http://api.sdswrite-qa.moveaws.com/v1/geo/",
    GEO_API_DISTANCE: "25",
    GEO_API_LIMIT: "30",
    GEO_API_CLIENT_ID: "FAR2.0",

    GEO_PREDICTIVETEXT_API_URL: "https://api.frontdoor.qa.realtor.com/parser/suggest",
    GEO_PREDICTIVETEXT_API_IP_LOCATION_ENDPOINT: "?client_id=far&input=",

    ADDRESS_VALIDATION_API: "https://api.frontdoor.qa.realtor.com/parser/search",

    LEAD_CAPTURE_BASE_URI: "http://qa.leadcapture.realtor.com/",
    LEAD_CAPTURE_PROJECT_ID: "FAR2.0",

    OMNITURE_BASE_URL: "//assets.adobedtm.com/faebb50624175676cb77dee13f41dc903c81f27e/",
    OMNITURE_END_POINT: "satelliteLib-55d21e8caa3d58b6207a9d1707e7dce9f3f19a44",

    FAR_BACKEND_API_BASE_URI: "https://frontdoor.cicd-stag.moveaws.com/far-backend-ecs-keyless",
    FAR_BACKEND_MULTIPLE_ADV_API_BASE_URI: "/api/agents/advertiser-ids",
    FAR_BACKEND_API_AGENTS_END_POINT: "/api/agents/search",
    FAR_BACKEND_CLIENT_ID: "FAR2.0",
    FAR_TIMEOUT_MS: "750",

    SRP_BASE_URL: "https://qa.realtor.com",

    UCS_BASE_URI: "http://qaf.services.realtor.com/ucs",

    APP_BASE_URL: "https://qa.realtor.com",
    PROFILE_APP_BASE_URL: "https://qa.realtor.com",
    GLOBAL_HEADER_BASE_URL: "https://qa.realtor.com",

    SKIP_LOGIN: "true",

    ENABLE_OPTIMIZELY: "false",
    ENABLE_DART: "false",
    ENABLE_KRUX: "false",

    FACEBOOK_API_URI: "https://graph.facebook.com/",
    FACEBOOK_API_POSTS_END_POINTS: "/posts",
    FACEBOOK_API_FEEDS_END_POINTS: "/feed",
    FACEBOOK_API_VERSION: "",
    FACEBOOK_FEED_REQUIRED_FIELDS: "created_time,place",
    FACEBOOK_POST_REQUIRED_FIELDS: "created_time,message,actions,picture,privacy,permalink_url",

    TWITTER_API: "https://api.twitter.com",
    TWITTER_CONSUMER_KEY: process.env.TWITTER_CONSUMER_KEY,
    TWITTER_CONSUMER_SECRET: process.env.TWITTER_CONSUMER_SECRET,

    REVIEW_SERVICE_API_BASE_URI: "https://reviews-service.tphub-qa.moveaws.com",

    HESTIA_API_BASE_URI: "https://frontdoor.cicd-stag.moveaws.com/graphql-internal",

    RECAPTCHA_KEY: process.env.RECAPTCHA_KEY,

    UDH_API_BASE_URI: "https://customer-identity-service.entsys-qa.moveaws.com",
    UDH_API_END_POINT: "/api/v2/offices",
    UDH_API_CLIENT_ID: "FAR2.0",

    HOSTNAME: "https://far-ui.cicd-stag.moveaws.com",
    LISTING_BASE_URL: "https://www.realtor.com",
    DOT_REALTOR_MAP_KEY: process.env.DOT_REALTOR_MAP_KEY,
    REALTOR_MAP_KEY: process.env.REALTOR_MAP_KEY,
    SENDGRID_APIV3_KEY: process.env.SENDGRID_APIV3_KEY,
    SEO_GOVERNANCE: "http://rdc-seo-zoho.rdc-qa.moveaws.com",
    SEO_ZOHO: "https://seo-zoho-api.rdc.moveaws.com",
    RDC_X_API_GATEWAY_URL: "https://rdc-x-api-private.sandbox-qa.realtor.com",
    FRONTDOOR_SERVER: "https://frontdoor.cicd-dev.moveaws.com",
  },
  LOG_LEVEL: "WARN",
  HOST_IP: "127.0.0.1",
  ENVIRONMENT: "qa",
  DATAFILETIMEOUT: 1000,
  AMPLITUDE_API_KEY: process.env.AMPLITUDE_API_KEY,
  AMPLITUDE_DEPLOYMENT_KEY: process.env.AMPLITUDE_DEPLOYMENT_KEY,
  CRYPTO_PASSWORD: process.env.CRYPTO_PASSWORD,
};
